import { SearchProps } from '~components/form-fields/search';

import { selectLookupFundingTypes } from '~support-at-home/selectors/fundingTypes';

export const searchFields: SearchProps = {
  client_name: {
    persist: true,
    defaultShow: true,
    type: 'text-like',
    field: ['first_name', 'surname'],
    placeholder: 'Client Name',
    caption: 'Client Name',
  },
  created_at: {
    persist: true,
    defaultShow: true,
    type: 'date-range',
    field: 'created_at',
    caption: 'Reconciliation',
  },
  claim_created_at: {
    defaultShow: false,
    type: 'date-range',
    field: 'claim.created_at',
    caption: 'Claim',
  },
  funding_source_ids: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'funding_source_ids',
    caption: 'Funding Type',
    selectorOptions: selectLookupFundingTypes,
  },
};
